import {ApolloClient, ApolloLink, gql, HttpLink, InMemoryCache} from "@apollo/client";
import {onError} from "@apollo/client/link/error";

import cfg from "../config/general-config"
import {apiUrls} from "./gen-utils";

/**
 * @sources:
 *  - https://www.sitepoint.com/how-to-build-a-web-app-with-graphql-and-react/
 *  - https://www.apollographql.com/docs/react/get-started/
 *  - https://www.apollographql.com/docs/react/get-started/
 *  - https://www.apollographql.com/docs/react/networking/authentication/
 *
 *
 * @type {DefaultClient<unknown>}
 */
const client = new ApolloClient({
    link: ApolloLink.from([
        onError(({graphQLErrors, networkError}) => {
            if (graphQLErrors)
                graphQLErrors.forEach(({message, locations, path}) => {
                    console.log(
                        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
                    )
                })

            if (networkError)
                console.log(`[Network error]: ${networkError}`)
        }),
        new HttpLink({
            uri: apiUrls.gql(),
            credentials: 'include'
        })
    ]),
    cache: new InMemoryCache({
        addTypename: true // important to keep it
    })
})

export const mainGqlTemplates = {
    GET_BOOKED_DAYS: gql`
        query GetFullyBookedSlots($month: String!) {
            fullDays(month: $month) {
                stilts
                cabanitas
                kaboum
            }
        }
    `,

    GET_CLOSED_PERIODS: gql`
        query ClosedPeriods {
            getClosedPeriods {
                stilts
                cabanitas
                kaboum
            }
        }
    `
}

export {
    client as xGqlMain,
}